import { callApi } from 'utils/api'
import crud from './_crud'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

const entity = 'equipment_owner'

const actions = crud(
	entity,
	'el propietario del equipo',
	'los propietarios del equipo'
)

const getNextEquipmentOwnerCode = () => {
  return async (dispatch, getState) => {
    const state = getState()

    const res = await callApi(`/${entity}/utils/get_next_code`, {
      method: 'GET',
      headers: {
        Authorization: state.app.user.token,
      },
    })

    return res.body.data.nextCode

  }
}

const createEquipmentOwner = (data, { onSuccess } = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    try {
      const res = await callApi(`/${entity}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          Authorization: state.app.user.token,
        },
      });

      Swal.fire({
        title: t('¡Acción Realizada!'),
        text: t('Se agregó el remitente o destinatario correctamente.'),
        icon: 'success',
        confirmButtonText: t('OK'),
        showCloseButton: true,
      }).then((result) => {
        if (result.isConfirmed) onSuccess?.(res.body);
      });

      dispatch({
        type: `ADD_${entity.toUpperCase()}`,
        response: res.body
      })

      return { ok: true, data: res.body };
    } catch (error) {
      return { ok: false, error: error?.message || 'Error' };
    }
  };
};

const updateEquipmentOwner = (item, { onSuccess } = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    try {
      let res = await callApi(`/${entity}/${item.id}`, {
        method: 'PATCH',
        body: JSON.stringify(item),
        headers: {
          Authorization: state.app.user.token
        },
      })

      Swal.fire({
        title: t('¡Acción realizada!'),
        text: t('Se actualizó el remitente o destinatario correctamente.'),
        icon: 'success',
        confirmButtonText: t('OK'),
        showCloseButton: true,
      }).then((result) => {
        if (result.isConfirmed) onSuccess?.(res.body);
      });

      dispatch({
        type: `UPDATE_${entity.toUpperCase()}`,
        response: res.body
      })

      return { ok: true, data: res.body };
    } catch (error) {
      Swal.fire('Error', error?.message || t('No se pudo actualizar'), 'error', {showCloseButton: true,});
      return { ok: false, error: error?.message || 'Error' };
    }
  };
};

const deleteEquipmentOwner = (item, { onSuccess } = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    try {
      const res = await callApi(`/${entity}/${item.id}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: state.app.user.token
          },
        })

      Swal.fire({
        title: t('¡Acción realizada!'),
        text: t('Se eliminó el remitente o destinatario correctamente.'),
        icon: 'success',
        confirmButtonText: t('OK'),
        showCloseButton: true,
      }).then((result) => {
        if (result.isConfirmed) onSuccess?.(res.body);
      });

      dispatch({
        type: `DELETE_${entity.toUpperCase()}`,
        response: { id: item.id }
      })

      return { ok: true, data: res.body };
    } catch (error) {
      Swal.fire('Error', error?.message || t('No se pudo eliminar'), 'error', {showCloseButton: true,});
      return { ok: false, error: error?.message || 'Error' };
    }
  };
}

const updateUnitsTrailers = ({ units, trailers, onSuccess } = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    try {
      let res = await callApi(`/${entity}/utils/update-units-trailers`, {
        method: 'PATCH',
        body: JSON.stringify({ units, trailers }),
        headers: {
          Authorization: state.app.user.token
        },
      })

      let updatedText = ''

      if (units.length > 0) updatedText = t('las unidades')
      if (trailers.length > 0) updatedText = t('los remolques')
      if (units.length > 0 && trailers.length > 0) updatedText = t('las unidades y remolques')
      
      Swal.fire({
        title: t('¡Acción realizada!'),
        text: `${t('Se actualizaron')} ${updatedText} ${t('correctamente.')}`,
        icon: 'success',
        confirmButtonText: t('OK'),
        showCloseButton: true,
      }).then((result) => {
        if (result.isConfirmed) onSuccess?.(res.body);
      })

      if (res.body?.units?.length) {
        res.body?.units.forEach((unit) => {
          dispatch({
            type: 'UPDATE_UNIT',
            response: unit
          })
        })
      }

      if (res.body?.trailers?.length) {
        res.body?.trailers.forEach((trailer) => {
          dispatch({
            type: 'UPDATE_TRAILER',
            response: trailer
          })
        })
      }
      
      return res.body
    } catch (error) {
      return { ok: false, error: error?.message || 'Error' };
    }
  };
};

export default { 
  ...actions,
  getNextEquipmentOwnerCode,
  createEquipmentOwner,
  updateEquipmentOwner,
  deleteEquipmentOwner,
  updateUnitsTrailers
}
